import { render } from "./contactCard.vue?vue&type=template&id=6ba2e579&scoped=true"
import script from "./contactCard.vue?vue&type=script&lang=js"
export * from "./contactCard.vue?vue&type=script&lang=js"

import "./contactCard.vue?vue&type=style&index=0&id=6ba2e579&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba2e579"]])

export default __exports__